import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Layout } from './components/Layout';
import { LandingPage } from './pages/LandingPage';
import { PlanEssential } from './pages/PlanEssential';
import { PlanSovereign } from './pages/PlanSovereign';
import { FeaturesPage } from './pages/FeaturesPage';
import { PricingPage } from './pages/PricingPage';
import { IntegrationPage } from './pages/IntegrationPage';
import { ChangelogPage } from './pages/ChangelogPage';
import { AboutPage } from './pages/AboutPage';
import { ContactPage } from './pages/ContactPage';
import { PrivacyPage } from './pages/PrivacyPage';
import { TermsPage } from './pages/TermsPage';
export function App() {
  return <Router data-id="element-0">
      <Layout data-id="element-1">
        <Routes data-id="element-2">
          <Route path="/" element={<LandingPage data-id="element-4" />} data-id="element-3" />
          <Route path="/plan/essential" element={<PlanEssential data-id="element-6" />} data-id="element-5" />
          <Route path="/plan/sovereign" element={<PlanSovereign data-id="element-8" />} data-id="element-7" />
          <Route path="/features" element={<FeaturesPage data-id="element-10" />} data-id="element-9" />
          <Route path="/pricing" element={<PricingPage data-id="element-12" />} data-id="element-11" />
          <Route path="/integration" element={<IntegrationPage data-id="element-14" />} data-id="element-13" />
          <Route path="/changelog" element={<ChangelogPage data-id="element-16" />} data-id="element-15" />
          <Route path="/about" element={<AboutPage data-id="element-18" />} data-id="element-17" />
          <Route path="/contact" element={<ContactPage data-id="element-20" />} data-id="element-19" />
          <Route path="/privacy" element={<PrivacyPage data-id="element-22" />} data-id="element-21" />
          <Route path="/terms" element={<TermsPage data-id="element-24" />} data-id="element-23" />
        </Routes>
      </Layout>
    </Router>;
}